/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Labels_Group_PageInputs */

const en_reading_labels_group_page = /** @type {(inputs: Reading_Labels_Group_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page extras`)
};

const es_reading_labels_group_page = /** @type {(inputs: Reading_Labels_Group_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras de la página`)
};

/**
* | output |
* | --- |
* | "Page extras" |
*
* @param {Reading_Labels_Group_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_labels_group_page = /** @type {((inputs?: Reading_Labels_Group_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Labels_Group_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_labels_group_page(inputs)
	return en_reading_labels_group_page(inputs)
});